import { Component, OnInit } from '@angular/core';
import { VisitorManagementService } from '../visitor-management.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-visitor-safety-training-paper',
  templateUrl: './visitor-safety-training-paper.component.html',
  styleUrls: ['./visitor-safety-training-paper.component.css']
})
export class VisitorSafetyTrainingPaperComponent implements OnInit {
  applicationNo: string = '';
  showQuestions: boolean = false;
  currentQuestionIndex: number = 0;
  showResults: boolean = false;
  userAnswers: any[] = [];
  participantName: string = '';
  ticketNo: string = '';
  isSubmitting: boolean = false;

  questions = [
    {
      id: 1,
      question: 'Name of Participant प्रतिभागी का नाम',
      type: 'text',
      answer: ''
    },
    {
      id: 2,
      question: 'Ticket No. / Employee No.',
      type: 'text',
      answer: ''
    },
    {
      id: 3,
      question: 'Does discovering a spill of water or oil on the floor qualify as a near miss in workplace safety?            क्या फर्श पर पानी या तेल का फैलना कार्यस्थल सुरक्षा में एक निकट चूक के रूप में योग्य माना जाता है?',
      type: 'radio',
      options: ['Yes हाँ', 'No नहीं'],
      correctAnswer: 'Yes हाँ',
      answer: ''
    },
    {
      id: 4,
      question: 'What does the abbreviation DTC stand for in the context of workplace safety?          कार्यस्थल सुरक्षा के संदर्भ में डीटीसी का संक्षिप्त रूप क्या है?',
      type: 'radio',
      options: [
        'Do The Check - जाँच करें',
        'Direct To Communicate - सीधे संवाद करने के लिए',
        'Drive To Control - नियंत्रण के लिए ड्राइव',
        'Dare To Care - देखभाल करने का साहस करें'
      ],
      correctAnswer: 'Dare To Care - देखभाल करने का साहस करें',
      answer: ''
    },
    {
      id: 5,
      question: 'In the context of workplace safety, what does the abbreviation LOF stand for?        कार्यस्थल सुरक्षा के संदर्भ में, LOF का संक्षिप्त रूप क्या है?',
      type: 'radio',
      options: [
        'Line Of Feet - पैरों की रेखा',
        'Level Of Force - बल का स्तर',
        'Line Of Fire - आग की रेखा',
        'List Of Findings - निष्कर्षों की सूची'
      ],
      correctAnswer: 'Line Of Fire - आग की रेखा',
      answer: ''
    },
    {
      id: 6,
      question: 'What does the acronym LOTOTO represent in workplace safety procedures?        कार्यस्थल सुरक्षा प्रक्रियाओं में LOTOTO का संक्षिप्त नाम क्या दर्शाता है?',
      type: 'radio',
      options: [
        'Look Over Take Out Turn Off - देखो बाहर ले जाओ बंद करो',
        'Leave Out Turn Off Turn On - छोड़ें बंद करें चालू करें',
        'Lock Out Tag Out Try Out - लॉक आउट टैग आउट ट्राई आउट',
        'Lock On Turn On Turn Off - लॉक चालू करें चालू करें बंद करें'
      ],
      correctAnswer: 'Lock Out Tag Out Try Out - लॉक आउट टैग आउट ट्राई आउट',
      answer: ''
    },
    {
      id: 7,
      question: 'Within the ABC model of Behaviour Based Safety (BBS), what does the term \'Antecedent\' refer to?             व्यवहार आधारित सुरक्षा (बीबीएस) के एबीसी मॉडल के अंतर्गत \'पूर्ववर्ती\' शब्द का क्या अर्थ है?',
      type: 'radio',
      options: [
        'An action that is observable and measurable. - एक क्रिया जो अवलोकनीय और मापनीय हो।',
        'A stimulus or event that occurs before a specific behaviour. - एक उत्तेजना या घटना जो किसी विशिष्ट व्यवहार से पहले घटित होती है।',
        'A result or outcome that follows a behaviour. - किसी व्यवहार के बाद आने वाला परिणाम या परिणाम।'
      ],
      correctAnswer: 'A stimulus or event that occurs before a specific behaviour. - एक उत्तेजना या घटना जो किसी विशिष्ट व्यवहार से पहले घटित होती है।',
      answer: ''
    },
    {
      id: 8,
      question: 'Which of the following best describes \'horseplay\' in the workplace?         निम्नलिखित में से कौन सा कार्यस्थल में \'हॉरप्ले\' का सबसे अच्छा वर्णन करता है?',
      type: 'radio',
      options: [
        'Riding a horse at work - काम पर घोड़े की सवारी करना',
        'Taking a break to play board games - बोर्ड गेम खेलने के लिए ब्रेक लेना।',
        'Engaging in rough physical activities that can cause accidents. - ऐसी कठोर शारीरिक गतिविधियों में संलग्न होना जिनसे दुर्घटनाएं हो सकती हैं।'
      ],
      correctAnswer: 'Engaging in rough physical activities that can cause accidents. - ऐसी कठोर शारीरिक गतिविधियों में संलग्न होना जिनसे दुर्घटनाएं हो सकती हैं।',
      answer: ''
    },
    {
      id: 9,
      question: 'Which control method should be implemented first according to the hierarchy of hazard control?          खतरा नियंत्रण के पदानुक्रम के अनुसार कौन सी नियंत्रण विधि पहले लागू की जानी चाहिए?',
      type: 'radio',
      options: [
        'Substitution - प्रतिस्थापन',
        'PPE – Personal Protective Equipment - पीपीई - व्यक्तिगत सुरक्षा उपकरण',
        'Elimination - उन्मूलन',
        'Engineering Control - इंजीनियरिंग नियंत्रण'
      ],
      correctAnswer: 'Elimination - उन्मूलन',
      answer: ''
    },
    {
      id: 10,
      question: 'Which do you believe has a greater effect on human behavior?       आपके अनुसार मानव व्यवहार पर किसका अधिक प्रभाव पड़ता है?',
      type: 'radio',
      options: [
        'Antecedents - पूर्ववर्ती',
        'Consequences - परिणाम',
        'Both equally - दोनों समान रूप से'
      ],
      correctAnswer: 'Consequences - परिणाम',
      answer: ''
    },
    {
      id: 11,
      question: 'What is the primary reason for most workplace accidents?            कार्यस्थल पर होने वाली अधिकांश दुर्घटनाओं का मुख्य कारण क्या है?',
      type: 'radio',
      options: [
        'Unsafe Condition - असुरक्षित स्थिति',
        'Unsafe Act - असुरक्षित कार्य'
      ],
      correctAnswer: 'Unsafe Act - असुरक्षित कार्य',
      answer: ''
    },
    {
      id: 12,
      question: 'Which sense is considered the strongest in humans?            मनुष्य में कौन सी इन्द्रिय सबसे मजबूत मानी जाती है?',
      type: 'radio',
      options: [
        'Taste - स्वाद',
        'Smell - गंध',
        'Vision - दृष्टि',
        'Audiometry Hearing - श्रवण - संबंधी'
      ],
      correctAnswer: 'Vision - दृष्टि',
      answer: ''
    },
    {
      id: 13,
      question: 'In Behaviour Based Safety, what do the letters A, B, and C stand for in the ABC model?           व्यवहार आधारित सुरक्षा में, एबीसी मॉडल में ए, बी और सी अक्षर क्या दर्शाते हैं?',
      type: 'radio',
      options: [
        'A-Assessment, B-Benefit, C-Control -  A-मूल्यांकन, B-लाभ, C-नियंत्रण',
        'A-Antecedents, B-Behaviour, C-Consequences - A-पूर्ववृत्त, B-व्यवहार, C-परिणाम'
      ],
      correctAnswer: 'A-Antecedents, B-Behaviour, C-Consequences - A-पूर्ववृत्त, B-व्यवहार, C-परिणाम',
      answer: ''
    }
  ];

  constructor(private visitorService: VisitorManagementService) { }

  ngOnInit() {
  }

  submitApplicationNo() {
    if (this.applicationNo.trim()) {
      this.showQuestions = true;
    }
  }

  selectAnswer(answer: string) {
    this.questions[this.currentQuestionIndex].answer = answer;
  }

  nextQuestion() {
    if (this.currentQuestionIndex < this.questions.length - 1) {
      this.currentQuestionIndex++;
    }
  }

  previousQuestion() {
    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
    }
  }

  submitTest() {
    this.isSubmitting = true;
    const testPaperData = this.prepareTestPaperJSON();
    const payload = this.createPayload(testPaperData);

    this.visitorService.createVisitor(payload).subscribe(
      (response) => {
        this.isSubmitting = false;
        this.showResults = true;
        console.log('Test submitted successfully', response);
      },
      (error) => {
        this.isSubmitting = false;
        console.error('Error submitting test', error);
        alert('Failed to submit test. Please try again.');
      }
    );
  }

  prepareTestPaperJSON(): string {
    const testData = [];
    
    for (let i = 2; i < this.questions.length; i++) {
      const q = this.questions[i];
      if (q.type === 'radio') {
        const questionObj: any = {
          question: q.question
        };
        
        q.options.forEach((opt, idx) => {
          questionObj[String.fromCharCode(65 + idx)] = opt;
        });
        
        const answerIndex = q.options.indexOf(q.answer);
        questionObj.answer = answerIndex >= 0 ? String.fromCharCode(65 + answerIndex) : '';
        
        testData.push(questionObj);
      }
    }
    
    return JSON.stringify(testData).replace(/"/g, '\\"');
  }

  createPayload(testPaperJSON: string): any {
    const guid = '47DF4E41-7E65-40EF-930B-257B8F61E215';
    const score = this.getScorePercentage();
    
    return {
      [guid]: {
        ID: null,
        Page_Code: 424,
        Referance_Code: parseInt(this.applicationNo) || 123,
        TestPaperJSON: testPaperJSON,
        MarksPoint: score.toFixed(2),
        ResultStatusMIL_Code: 123,
        CreatedBy: 100,
        Modifiedby: 100,
        IsActive: 1,
        IsDeleted: 0
      }
    };
  }

  isAnswerCorrect(question: any): boolean {
    if (question.type === 'text') return true;
    return question.answer === question.correctAnswer;
  }

  goToQuestion(index: number) {
    this.currentQuestionIndex = index;
    this.showResults = false;
  }

  getProgress(): number {
    return Math.round(((this.currentQuestionIndex + 1) / this.questions.length) * 100);
  }

  getOptionLetter(index: number): string {
    return String.fromCharCode(65 + index);
  }

  getCorrectAnswers(): number {
    return this.questions.filter(q => this.isAnswerCorrect(q)).length;
  }

  getWrongAnswers(): number {
    return this.questions.filter(q => q.type === 'radio' && !this.isAnswerCorrect(q)).length;
  }

  getScorePercentage(): number {
    const radioQuestions = this.questions.filter(q => q.type === 'radio');
    const correctAnswers = radioQuestions.filter(q => this.isAnswerCorrect(q)).length;
    return Math.round((correctAnswers / radioQuestions.length) * 100);
  }
}
